import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { RegimeScheduleTotalCaption } from "./regime-schedule-total-caption"
import { useRegimeScheduleTotal } from "./use-regime-schedule-total"

export function SelectorRegimeScheduleTotal() {
    const context = useBoundContext()
    const fromIndex = Object.hasOwn(context, "selectedRegimeTreeId")
    const selectedId = fromIndex ? context.selectedRegimeTreeId : context.parentId
    const total = useRegimeScheduleTotal(context.parentItem, selectedId, { fromIndex })
    if (!total) return null
    return <RegimeScheduleTotalCaption total={total} />
}
